import React from 'react';
import { CarretArrowDown } from 'apgdev/src/js/components/atoms/icons';
export const theme = 'Sportscraft';

export const SelectDropdownIcon = () => <CarretArrowDown />;
